/**
 * @flow
 * @relayHash a6bae32831980a43f57d60d0c641207a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LocaleSelectQueryVariables = {| |};
export type LocaleSelectQueryResponse = {|
  +allLocales: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +display: string,
        +code: string,
      |},
    |}>,
  |},
|};
*/


/*
query LocaleSelectQuery {
  allLocales {
    edges {
      node {
        display
        code
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "display",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "LocaleSelectQuery",
  "id": null,
  "text": "query LocaleSelectQuery {\n  allLocales {\n    edges {\n      node {\n        display\n        code\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "LocaleSelectQuery",
    "type": "LarkSeedsAPI",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "allLocales",
        "storageKey": null,
        "args": null,
        "concreteType": "LocaleConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "LocaleEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Locale",
                "plural": false,
                "selections": [
                  v0,
                  v1
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "LocaleSelectQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "allLocales",
        "storageKey": null,
        "args": null,
        "concreteType": "LocaleConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "LocaleEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Locale",
                "plural": false,
                "selections": [
                  v0,
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "id",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = '315682284c25fe909dfbde629b352f1b';
module.exports = node;



// WEBPACK FOOTER //
// ./src/views/Root/Nav/__generated__/LocaleSelectQuery.graphql.js